import { ReactComponent as Wow } from 'assets/images/videoReactions/wow.svg';
import styled from 'styled-components/macro';

const WowIcon = styled(Wow)`
  width: ${props => props.width || '24px'};
  height: ${props => props.height || '24px'};
`;

export default WowIcon;
